import React from "react";
import { Link } from "react-router-dom"
import cx from "classnames";
import { useSelector } from "react-redux"
import { updateJobServiceTransition } from "requesters/jobServiceRequester"
import { INVOICE_STATES, JOB_STATES_DISPLAY, CANCELLED } from "utils/constants"
import { getBaseUrl } from "../../reducers"

export default function AccountsRow({ job, fetchData }) {
  const {
    id,
    jobId,
    jobNo,
    forProjectX,
    projectXJobNo,
    jobAddress,
    clientName: contact,
    code,
    cost,
    accountType,
    invoiceType,
    accountsInvoiceState,
    state,
    refundTypeLabel,
    payBeforeDrafting,
    previousState,
    hasEmailIssue,
  } = job.attributes;

  const baseUrl = useSelector(getBaseUrl)
  const transition = (state === "to_invoice") ? "set-to-ready-to-send" : "mark-as-paid"
  const displayJobNo = forProjectX ? projectXJobNo : jobNo

  const getInvoiceStatusColumn = () => {
    const isDraftedAndPayBeforeDrafting = ["deposit_invoice_drafted", "final_invoice_drafted"].includes(accountsInvoiceState) && payBeforeDrafting
    if (isDraftedAndPayBeforeDrafting) return { bgClass: "bg-green", text: "Invoice Sent (Pay Before Drafting)" }
    return { bgClass: INVOICE_STATES[accountsInvoiceState]?.bgClass, text: INVOICE_STATES[accountsInvoiceState]?.text }
  }

  const invoiceStatusColumn = getInvoiceStatusColumn()
  const invoiceStateColor = invoiceStatusColumn.bgClass
  const invoiceStateText = invoiceStatusColumn.text


  const markAsPaidHandler = () => {
    updateJobServiceTransition(baseUrl, id, transition)
      .then(res => {
        if (res.status === 200) {
          fetchData()
        }
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log(err))
  }

  const stateRender = () => {
    if (state === CANCELLED) {
      return {
        text: `${JOB_STATES_DISPLAY[state]?.text} - ${refundTypeLabel}`,
        bgClass: JOB_STATES_DISPLAY[state]?.bgClass
      }
    }
    if (["awaiting_payment", "to_invoice"].includes(state) && accountsInvoiceState === "deposit_invoice_drafted") {
      return JOB_STATES_DISPLAY.awaiting_payment_deposit
    }
    if (["awaiting_payment", "to_invoice"].includes(state) && accountsInvoiceState === "final_invoice_drafted") {
      return JOB_STATES_DISPLAY.awaiting_payment_final
    }
    if (state === "awaiting_payment") {
      return JOB_STATES_DISPLAY[previousState]
    }
    return JOB_STATES_DISPLAY[state]
  }

  return (
    <tr>
      <td>
        <Link to={`/jobs/${jobId}/job_services/${id}`} className="link-no-decoration">{displayJobNo}</Link>
      </td>
      <td>
        <Link to={`/jobs/${jobId}/job_services/${id}`} className="link-no-decoration">{jobAddress}</Link>
      </td>
      <td>
        <Link to={`/jobs/${jobId}/job_services/${id}`} className="link-no-decoration">{code}</Link>
      </td>
      <td>
        <Link to={`/jobs/${jobId}/job_services/${id}`} className="link-no-decoration d-flex align-items-center">
          {contact}
          {hasEmailIssue && (
            <span
              title="Invoice contact is missing an email address — the auto final invoice could not be sent automatically. Please update the contact's email."
              style={{
                marginLeft: '6px',
                display: 'inline-flex',
                alignItems: 'center',
                cursor: 'help',
                color: '#e67e22',
                flexShrink: 0,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                fill="currentColor"
                viewBox="0 0 16 16"
              >
                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
              </svg>
            </span>
          )}
        </Link>
      </td>
      <td>
        <Link to={`/jobs/${jobId}/job_services/${id}`} className="link-no-decoration">{accountType}</Link>
      </td>
      <td>
        <Link to={`/jobs/${jobId}/job_services/${id}`} className="link-no-decoration">{invoiceType}</Link>
      </td>
      <td className={cx(`dropdown text-center ${invoiceStateColor}`)}>
        <button
          className="btn dropdown-toggle"
          disabled
          type="button">
          {invoiceStateText}
        </button>
      </td>
      <td className={cx(`dropdown text-center ${stateRender()?.bgClass} border-left border-white`)}>
        <button
          className="btn dropdown-toggle"
          disabled
          type="button">
          {stateRender()?.text}
        </button>
      </td>
      {/* <StatusChangeDropdown job={job} reloadData={fetchData} jobStates={jobStates} updatableStates={updatableStates} updatableOptions={updatableOptions} /> */}
      <td className="text-center">
        <Link to={`/jobs/${jobId}/job_services/${id}`} className="link-no-decoration">{`$${cost}`}</Link>
      </td>
      {/* <td className="text-center"></td> */}
      <td>
        <div className="d-flex align-items-center justify-content-end">
          <a href={`/jobs/${jobId}/job_services/${id}`}>Details</a>
        </div>
      </td>
      {/* <td>
        <div className="dropdown">
          <button className="btn" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled={currentState(state) !== "invoice_sent"}>
            <i className="bi bi-three-dots-vertical" />
          </button>
          {currentState(state) === "invoice_sent" && (
          <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <button className="dropdown-item" type="button" onClick={markAsPaidHandler}>Mark as Paid</button>
          </div>
          )}
        </div>
      </td> */}
    </tr>
  );
}
